import { client } from "../../client";
import { escapeChat } from "../../encoding";

/**
 * Requests to change the music to the specified track.
 * @param {string} track the track ID
 */
export const sendMusicChange = (track: string) => {
  const showname = escapeChat((<HTMLInputElement>document.getElementById("ic_chat_name")).value);
  const flags = 0;
  client.sender.sendServer(`MC#${track}#${client.charID}#${showname}#${flags}#%`);
};
